/**
 * Ключ намерения с ресурсом: `<rid>|<что>`. rid — первым и в нижнем регистре:
 * одинаковые места/кассы двух AQSI — разные ключи, а сброс области ресурса
 * удаляет ровно его записи.
 */
export function ridKey(resourceId: string, rest: string): string {
  return `${resourceId.toLowerCase()}|${rest}`
}

export function belongsToResource(key: string, resourceId: string): boolean {
  return key.startsWith(`${resourceId.toLowerCase()}|`)
}

/** Удалить из словаря записи ресурса (по `resourceScopeCleared`). */
export function dropResource<T>(map: Record<string, T>, resourceId: string): void {
  for (const key of Object.keys(map)) if (belongsToResource(key, resourceId)) delete map[key]
}
